module.exports = {
  title: 'Blurred TabBar with Expo Blur 🎨',
  author: 'Enzo Manuel Mangano',
  date: '2023-12-06',
  slug: 'blurred-bottom-bar',
  tags: ['react-navigation'],
};
